<template>
  <v-card class="elevation-0">
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      v-model="selectedItems"
      :single-select="!multiSelect"
      :show-select="multiSelect"
      :headers="headers"
      :items="fumkmFiles"
      :page.sync="currentPage"
      :items-per-page="pageSize"
      hide-default-footer
      class="elevation-0"
      @page-count="totalTablePages = totalPaginationPages"
    >
      <template v-slot:top>
        <v-row align="center" class="ml-4 mr-4">
          <v-switch
            v-model="multiSelect"
            :label="multiSelect ? 'Multi Select' : 'Single Select'"
            x-small
          ></v-switch>
          <v-btn
            fab
            dark
            color="red accent-4"
            x-small
            :disabled="!multiSelect"
            class="mr-2"
            @click="deleteDialogMultiShow"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            fab
            dark
            color="green"
            x-small
            @click="showSelectDialog=true"
            class="ml-1"
            v-if="
              !multiSelect && itemModified.kode1 !== '' &&
              (itemModified.fdivisionBean !== undefined || itemModified.fdivisionBean !== '') &&
              (itemModified.fsubAreaBean !== undefined || itemModified.fsubAreaBean !== '') &&
              (itemModified.fumkmTypebean !== undefined || itemModified.fumkmTypebean !== '')  &&
              itemModified.description !== ''">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </template>
      <template v-slot:[`item.number`]="{ index }">
        {{ index + (currentPage - 1) * pageSize + 1 }}
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <div class="font-weight-bold" v-if="item.jenis === 6 && item.description">{{ item.description }}</div>
        <div class="caption font-weight-light blue--text">{{ item.fileName }}</div>
      </template>
      <template v-slot:[`item.jenis`]="{ item }">
        <v-chip small dark :color="getJenisFileColor(item.jenis)">{{ getJenisFileName(item.jenis) }}</v-chip>
      </template>
      <template v-slot:[`item.statusActive`]="{ item }">
        <v-chip :color="getColorStatusActive(item.statusActive)" dark x-small>
          {{ item.statusActive === true ? "Aktif" : "Non Aktif" }}
        </v-chip>
      </template>
      <template v-slot:[`item.avatarImage`]="{ item }">
        <v-img
          :lazy-src="lookupImageUrlLazy(item)"
          :src="lookupImageUrl(item)"
          v-if="item.fileType === 'IMAGE'"
          alt="avatar"
          width="80px"
          height="80px"
          class="ma-2 rounded"
        >
        </v-img>
        <div class="my-4" v-else-if="item.fileType === 'MP4'">
          <Media
              :kind="'video'"
              :isMuted="false"
              :src="urlMp4File(item)"
              :controls="true"
              :autoplay="false"
              :loop="true"
              :ref="'fish'"
              :style="{ width: '130px' }"
              @pause="handle()"
          >
          </Media>
        </div>
<!--        <div class="subtitle-1 font-weight-bold" v-else-if="item.fileType === 'DOC'">-->
<!--          FILE-->
<!--        </div>-->
      </template>
      <template v-slot:[`item.actions`]="{ item }">

        <v-btn :disabled="multiSelect" @click="deleteDialogShow(item)" icon>
          <v-icon small color="red accent-4"> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-container v-if="false">
      <v-row justify="end" align="center">
        <v-col cols="4" md="2" sm="2">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per page"
          ></v-select>
        </v-col>
        <v-col cols="5" md="5" sm="8" align="right">
          <v-pagination
            v-model="currentPage"
            :length="totalPaginationPages"
            total-visible="8"
            circle
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <DeleteConfirmDialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></DeleteConfirmDialog>
    <UploadImageDialog
        ref="refUploadImageDialog"
        @eventUploadSuccess="completeUploadImageSuccess"
    ></UploadImageDialog>
    <UploadMp4Dialog
        ref="refUploadDialogMp4"
        @eventUploadSuccess="completeUploadMp4Success"
    ></UploadMp4Dialog>
    <UploadDocumentSimpleDialog
        ref="refUploadDocSimpleDialog"
        @eventUploadSuccess="completeUploadDocSimpleSuccess"
    ></UploadDocumentSimpleDialog>
    <UploadDocumentDialog
        ref="refUploadDocDialog"
        @eventUploadSuccess="completeUploadDocSuccess"
    ></UploadDocumentDialog>
    <v-dialog
        v-model="showSelectDialog"
        :max-width="formDialogOptions.width"
        :style="{ zIndex: formDialogOptions.zIndex }"
        @keydown.esc.prevent="showSelectDialog = false"
        persistent
        :hide-overlay="$vuetify.breakpoint.smAndDown"
    >
      <v-card rounded>
        <v-card-title >
          <v-spacer></v-spacer>
          <v-btn icon @click="showSelectDialog=false" large><v-icon color="red" large>mdi-close-circle-outline</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout wrap class="d-flex mt-2 justify-center">
            <div v-for="(item, i) in FUmkmFileType" :key="i">
              <div>
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card
                        @click="showSelectUploadType(item)"
                        width="210"
                        height="250"
                        xs12
                        sm4
                        px-3
                        class="ma-3 rounded-lg pb-6"
                        :elevation="hover ? 16 : 3"
                    >
                      <div>
                        <v-hover>
                          <template v-slot:default="{ hover }">
                            <v-img
                                style="background-color: white"
                                height="165"
                                :lazy-src="item.avatarImage"
                                :src="item.avatarImage"
                                :class="{ 'hover-image': hover }"
                                class="rounded-lg mx-6 mt-2 mb-1"
                            ></v-img>
                          </template>
                        </v-hover>
                      </div>
                      <v-divider class="mx-4 mt-2"></v-divider>
                      <v-card-title class="text-center justify-center subtitle-2 font-weight-bold">
                        {{item.description}}
                      </v-card-title>
                    </v-card>
                  </template>
                </v-hover>
              </div>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>

</template>

<script>
import DeleteConfirmDialog from "@/components/utils/DeleteConfirmDialog.vue";
import FormMode from "@/models/form-mode";
import FileService from "@/services/apiservices/file-service";
import UploadMp4Dialog from "@/components/utils/UploadMp4Dialog.vue";
import UploadImageDialog from "@/components/utils/UploadImageDialog.vue";

import FUmkmFile from "@/models/umkm/f-umkm-file";
import FUmkmFileService from "@/services/apiservices-umkm/f-umkm-file-service";
import UploadDocumentSimpleDialog from "@/components/utils/UploadDocumentSimpleDialog.vue";
import Media from "@dongido/vue-viaudio";
import UploadDocumentDialog from "@/components/utils/UploadDocumentDialog.vue";
export default {
  name: "FUmkmObjectFileTable",
  props: {
    itemModified: Object,
    newFUmkmId: Number,
  },
  components: {
    UploadDocumentDialog,
    Media,
    DeleteConfirmDialog,
    UploadImageDialog,
    UploadMp4Dialog,
    UploadDocumentSimpleDialog
  },
  data() {
    return {
      title: "Company Profile (File)",
      multiSelect: false,
      selectedItems: [],
      itemFUmkm: "",
      formDialogOptions: {
        title1: "",
        title2: "",
        message1: "",
        message2: "",
        errorMessage: "",
        color: "grey lighten-3",
        width: 500,
        zIndex: 200,
        noconfirm: false,
      },
      showSelectDialog: false,
      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 99,
      pageSizes: [10, 25, 50, 150, 500, 1500],
      FUmkmFileType: [
        // {id:1, jenis: 1, description: "Poster", avatarImage: require('@/assets/images/image-icon.jpg')},
        // {id:2, jenis: 2, description: "Teaser", avatarImage: require('@/assets/images/video-icon.jpg')},
        {id:3, jenis: 3, description: "File (PPT, Pdf, Word)", avatarImage: require('@/assets/images/file.jpg')},
      ],
      headers: [
        {
          text: "No",
          align: "start",
          sortable: false,
          value: "number",
          width: "8%"
        },
        // { text: "", value: "avatarImage", width: "12%" },
        { text: "File Name", value: "description", width: "35%" },
        { text: "Jenis File", value: "jenis", width: "22%", align: "center"},
        { text: "Actions", value: "actions", sortable: false },
      ],
      jenisFile: 0,
      itemSelectedIndex: -1,
      itemSelected: "",
      fumkmFiles: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    // itemModified: {
    //   get() {
    //     return this.$store.state.umkm.itemModified;
    //   },
    //   set(value) {
    //     this.$store.dispatch("umkm/updateItemModified", value);
    //   },
    // },
    formModeFUmkmFile: {
      get() {
        return this.$store.state.umkm.formModeFUmkmFile;
      },
      set(value) {
        this.$store.dispatch(
          "umkm/updateFormModeFUmkmFile",
          value
        );
      },
    },
    itemsFDivision: {
      get() {
        return this.$store.state.umkm.itemsFDivision;
      },
      set(value) {
        this.$store.dispatch("umkm/updateItemsFDivision", value);
      },
    },
  },
  watch: {
    itemFUmkm: {
      handler: function (value) {
        if (value) {
          if (value.id > 0) {
            this.runExtendedFilter();
          }
        }
      },
    },
  },
  methods: {
    completeUploadMp4Success: function (val) {
      if (val.fileName !== "") {
        let fumkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            this.jenisFile,
            "MP4",
            4,
            true
        );
        fumkmFileBean.modifiedBy = this.$store.state.auth.user.username;

        FUmkmFileService.createFUmkmFile(fumkmFileBean).then(
            () => {
              this.$refs.refUploadDialogMp4.closeDialog();
              //Just REfresh files
              this.runExtendedFilter()
            },
            (error) => {
              console.log(error.message);
            }
        );
      }
    },
    completeUploadImageSuccess: function (val) {
      if (val.fileName !== "") {
        let fumkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            this.jenisFile,
            "IMAGE",
            2,
            true,

        );
        fumkmFileBean.modifiedBy = this.$store.state.auth.user.username;

        FUmkmFileService.createFUmkmFile(fumkmFileBean).then(
            () => {
              this.$refs.refUploadImageDialog.closeDialog();
              //Just REfresh files
              this.runExtendedFilter()
            },
            (error) => {
              console.log(error.message);
            }
        );
      }
    },
    completeUploadDocSimpleSuccess: function (val) {
      if (val.fileName !== "") {
        let fumkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            this.jenisFile,
            "DOC",
            1,
            true,

        );
        fumkmFileBean.modifiedBy = this.$store.state.auth.user.username;

        FUmkmFileService.createFUmkmFile(fumkmFileBean).then(
            () => {
              this.$refs.refUploadDocSimpleDialog.closeDialog();
              //Just REfresh files
              this.runExtendedFilter()
            },
            (error) => {
              console.log(error.message);
            }
        );
      }
    },
    completeUploadDocSuccess: function (val) {
      if (val.fileName !== "") {
        let fumkmFileBean = new FUmkmFile(
            0,
            this.itemModified.id,
            val.fileName,
            val.description,
            this.jenisFile,
            "DOC",
            1,
            true,

        );
        fumkmFileBean.modifiedBy = this.$store.state.auth.user.username;

        FUmkmFileService.createFUmkmFile(fumkmFileBean).then(
            () => {
              this.$refs.refUploadDocDialog.closeDialog();
              //Just REfresh files
              this.runExtendedFilter()
            },
            (error) => {
              console.log(error.message);
            }
        );
      }
    },
    showSelectUploadType(item){
      this.$emit("saveCreateOnly");
      this.jenisFile = item.jenis
      this.showSelectDialog = false
      if(item.jenis === 1 || item.jenis === 4){
        this.$refs.refUploadImageDialog.showDialog();
      } else if(item.jenis === 2){
        this.$refs.refUploadDialogMp4.showDialog();
      } else if(item.jenis === 3 || item.jenis === 5){
        this.$refs.refUploadDocSimpleDialog.showDialog();
      } else if(item.jenis === 6){
        this.$refs.refUploadDocDialog.showDialog();
      }
    },
    fetchFUmkmFileByFUmkm(item) {
      this.itemFUmkm = item;
      this.runExtendedFilter();
    },
    fetchFUmkmFile() {
      this.runExtendedFilter();
    },
    runExtendedFilter() {
      if (this.itemModified.id > 0) {
        FUmkmFileService.getAllFUmkmFileByParent(
          this.itemModified.id
        ).then((response) => {
          this.fumkmFiles = response.data.filter(item => item.jenis === 3);
        });
      }
    },
    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      this.formModeFUmkmFile = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemFUmkm
      );
      if (this.formModeFUmkmFile === FormMode.NEW_FORM) {
        this.$emit("saveCreateOnly");
      }
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      /**
       * Setiap data baru harus terlihat
       */
      this.fetchFUmkmFile();
      this.$refs.refFormDialog.dialogShow = false;
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fumkmFiles.indexOf(item);
      const itemModified = Object.assign({}, item);
      this.formModeFUmkmFile = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(this.itemSelectedIndex, itemModified);
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      Object.assign(
        this.fumkmFiles[this.itemSelectedIndex],
        this.itemSelected
      );
      this.$refs.refFormDialog.dialogShow = false;
    },

    deleteDialogShow(item) {
      this.itemSelectedIndex = this.fumkmFiles.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      this.$refs.refDeleteConfirmDialog.showDialog(this.itemSelectedIndex);
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
          this.selectedItems,
          `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fumkmFiles[this.itemSelectedIndex];
      FUmkmFileService.deleteFUmkmFile(deletedItem.id).then(
        () => {
          this.fumkmFiles.splice(this.itemSelectedIndex, 1);
          this.$refs.refDeleteConfirmDialog.dialogShow = false;
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }

        FUmkmFileService.deleteAllFUmkmFile(itemIds).then(
          () => {
            this.selectedItems = [];
            this.$refs.refDeleteConfirmDialog.dialogShow = false;

            if (this.showFilter) {
              this.runExtendedFilter();
            } else {
              this.fetchFUmkmFile();
            }
          },
          (error) => {
            console.log("error " + error);
          }
        );
      }
    },
    lookupImageUrl(item) {
      if (item.fileName === undefined || item.fileName === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_low(item.fileName);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.fileName === undefined || item.fileName === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_verylow(item.fileName);
      }
    },
    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },
    getJenisFileName(jenisFile) {
      if (jenisFile === 3) return this.FUmkmFileType[0].description;

    },
    getJenisFileColor(jenisFile) {
      if (jenisFile === 1) return "primary"
      else if (jenisFile === 2) return "teal"
      else if (jenisFile === 3) return "light-green darken-1"
      else if (jenisFile === 4) return "amber darken-2"
      else if (jenisFile === 5) return "brown darken-1"
      else if (jenisFile === 6) return "indigo"
    },
    urlMp4File(item) {
      return FileService.fileStreamMp4File(item.fileName);
    },
    handle() {
      // console.log("Video paused!, playing in 2 sec...");

      setTimeout(() => {
        this.$refs.fish.play();
      }, 2000);
    },
  },
};
</script>